import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import FichaList from "./pages/Fichas/FichaList";
import FichaForm from "./pages/Fichas/FichaForm";
import RelatorioFicha from "./pages/Fichas/RelatorioFicha";
import FormularioList from "./pages/Formularios/FormularioList";
import FormularioBuilder from "./pages/Formularios/FormularioBuilder";
import UsuarioList from "./pages/Usuarios/UsuarioList";
import UsuarioForm from "./pages/Usuarios/UsuarioForm";
import EdicaoList from "./pages/Edicoes/EdicaoList";
import EdicaoForm from "./pages/Edicoes/EdicaoForm";
import RecursoList from "./pages/Recursos/RecursoList";
import RecursoForm from "./pages/Recursos/RecursoForm";
import EventoList from "./pages/Eventos/EventoList";
import EventoForm from "./pages/Eventos/EventoForm";
import EventosPublico from "./pages/Eventos/EventosPublico";
import InscritosList from "./pages/Eventos/InscritosList";
import PresencaList from "./pages/Eventos/PresencaList";
import PresencaCheckin from "./pages/Eventos/PresencaCheckin";
import TipoDocumentoList from "./pages/Documentos/TipoDocumentoList";
import CertificadoModeloList from "./pages/Certificados/CertificadoModeloList";
import CertificadoModeloForm from "./pages/Certificados/CertificadoModeloForm";
import FinanceiroList from "./pages/Eventos/FinanceiroList";
import ConfigPage from "./pages/Config/ConfigPage";
import InscricaoPage from "./pages/Inscricao/InscricaoPage";
import RedefinirSenha from "./pages/Inscricao/RedefinirSenha";
import Login from "./pages/Login/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./components/AdminLayout";

// Envolve uma página administrativa: protege a rota e aplica o layout (sidebar + topbar).
function Admin({ children }) {
  return (
    <ProtectedRoute>
      <AdminLayout>{children}</AdminLayout>
    </ProtectedRoute>
  );
}

function Shell() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/inscricao/:token" element={<InscricaoPage />} />
      <Route path="/redefinir-senha/:token" element={<RedefinirSenha />} />
      <Route path="/eventos" element={<EventosPublico />} />
      <Route path="/eventos/:id" element={<EventosPublico />} />
      <Route path="/presenca/:token" element={<PresencaCheckin />} />
      <Route path="/" element={<Navigate to="/fichas" replace />} />
      <Route path="/fichas" element={<Admin><FichaList /></Admin>} />
      <Route path="/fichas/:id/relatorio" element={<ProtectedRoute><RelatorioFicha /></ProtectedRoute>} />
      <Route path="/fichas/nova" element={<Admin><FichaForm /></Admin>} />
      <Route path="/fichas/:id" element={<Admin><FichaForm /></Admin>} />
      <Route path="/documentos" element={<Admin><TipoDocumentoList /></Admin>} />
      <Route path="/formularios" element={<Admin><FormularioList /></Admin>} />
      <Route path="/formularios/novo" element={<Admin><FormularioBuilder /></Admin>} />
      <Route path="/formularios/:id" element={<Admin><FormularioBuilder /></Admin>} />
      <Route path="/usuarios" element={<Admin><UsuarioList /></Admin>} />
      <Route path="/usuarios/novo" element={<Admin><UsuarioForm /></Admin>} />
      <Route path="/usuarios/:id" element={<Admin><UsuarioForm /></Admin>} />
      <Route path="/edicoes" element={<Admin><EdicaoList /></Admin>} />
      <Route path="/edicoes/nova" element={<Admin><EdicaoForm /></Admin>} />
      <Route path="/edicoes/:id" element={<Admin><EdicaoForm /></Admin>} />
      <Route path="/recursos" element={<Admin><RecursoList /></Admin>} />
      <Route path="/recursos/:id" element={<Admin><RecursoForm /></Admin>} />
      <Route path="/eventos-admin" element={<Admin><EventoList /></Admin>} />
      <Route path="/eventos-admin/novo" element={<Admin><EventoForm /></Admin>} />
      <Route path="/eventos-admin/:id" element={<Admin><EventoForm /></Admin>} />
      <Route path="/inscritos" element={<Admin><InscritosList /></Admin>} />
      <Route path="/presenca" element={<Admin><PresencaList /></Admin>} />
      <Route path="/certificados" element={<Admin><CertificadoModeloList /></Admin>} />
      <Route path="/certificados/novo" element={<Admin><CertificadoModeloForm /></Admin>} />
      <Route path="/certificados/:id" element={<Admin><CertificadoModeloForm /></Admin>} />
      <Route path="/financeiro" element={<Admin><FinanceiroList /></Admin>} />
      <Route path="/configuracoes" element={<Admin><ConfigPage /></Admin>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}
